import { selectFromAuthDto } from '../../models';

export default selectFromAuthDto()
  .accessToken
  .error((e) => e.message)
  .toString();
